/* eslint-disable react/no-unknown-property */
/* eslint-disable no-unused-vars */
import React from "react";
import { Row, Col, Form, Input, Tooltip, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";

import PropTypes from "prop-types";
import "./style.scss";

import crosImgForChildBagagge from "../../../assests/crosImgForChildBagagge.svg";

export function InputListsTest({
  style,
  checkNumbervalue,
  restField,
  key,
  name,
  lg,
  setFieldValue,
  handleChange,
  form,
  sm = { sm },
  md,
  arrOfData,
}) {
  const { result } = useSelector(
    (state) => state.appReducer.getPostShipmentReducer
  );

  return (
    <div style={{ paddingTop: "30px" }}>
      <Form.List name="fields">
        {(fields, { add, remove }) => {
          return (
            <div>
              {fields.map((field, name) => (
                <Row key={key} gutter={[24, 24]} style={{ paddingTop: "5px" }}>
                  <Col lg={lg} sm={sm} md={md}>
                    <Form.Item
                      label={
                        <span className="calculater-container-pikpin">
                          {" "}
                          Length per packet (Cm)
                        </span>
                      }
                      {...restField}
                      // name={"length" + name}
                      name={[field.name, "lengt"]}
                      style={style}
                      rules={[
                        {
                          required: true,
                          maxLength: 3,
                          message: "Please enter value",
                        },
                        () => ({
                          validator(_, value, callBack) {
                            const formdata = form
                              .getFieldValue("fields")
                              .find((item, index) => index === name);

                            let totalValue =
                              (+formdata?.width * +formdata?.height * +value) /
                              5000;

                            const newform = [];

                            form.getFieldValue("fields").map((item, i) => {
                              if (i === name) {
                                const data = {
                                  ...item,
                                  totalweight: totalValue.toFixed(2),
                                };
                                newform.push(data);
                              } else {
                                const data = {
                                  ...item,
                                };
                                newform.push(data);
                              }
                            });

                            callBack(
                              form.setFieldsValue({
                                fields: newform,
                              })
                            );
                          },
                        }),
                      ]}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    >
                      <Input
                        type="number"
                        className="pincodeInput"
                        placeholder="Enter length"
                        maxLength={3}
                        min={1}
                        onKeyPress={(e) => {
                          // if (checkNumbervalue(event)) {
                          //   e.preventDefault();
                          // }
                          if (e.target.value.length >= 3) {
                            e.target.value = e.target.value.substring(
                              0,
                              e.target.value.length - 1
                            );
                          }
                          if (e.code === "Minus") {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={lg} sm={sm} md={md}>
                    <Form.Item
                      label={
                        <span className="calculater-container-pikpin">
                          {" "}
                          Width per packet (Cm)
                        </span>
                      }
                      {...restField}
                      style={style}
                      dependencies={[`${field.name}length`]}
                      name={[field.name, "width"]}
                      rules={[
                        {
                          required: true,
                          message: "Please enter  value",
                        },
                        ({ getFieldValue, setFieldsValue }) => ({
                          validator(_, value, callBack) {
                            const formdata = form
                              .getFieldValue("fields")
                              .find((item, index) => index === name);

                            let totalValue =
                              (+formdata?.width * +formdata?.height * +value) /
                              5000;

                            const newform = [];

                            form.getFieldValue("fields").map((item, i) => {
                              if (i === name) {
                                const data = {
                                  ...item,
                                  totalweight: totalValue.toFixed(2),
                                };
                                newform.push(data);
                              } else {
                                const data = {
                                  ...item,
                                };
                                newform.push(data);
                              }
                            });

                            callBack(
                              form.setFieldsValue({
                                fields: newform,
                              })
                            );
                          },
                        }),
                      ]}
                      onChange={(e) => handleChange(e)}
                      onKeyPress={(event) => {
                        if (checkNumbervalue(event)) {
                          event.preventDefault();
                        }
                      }}
                    >
                      <Input
                        type="number"
                        className="pincodeInput"
                        placeholder="Enter width"
                        maxLength={3}
                        onKeyPress={(e) => {
                          if (e.target.value.length >= 3) {
                            e.target.value = e.target.value.substring(
                              0,
                              e.target.value.length - 1
                            );
                          }
                          if (e.code === "Minus") {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={lg} sm={sm} md={md}>
                    <Form.Item
                      label={
                        <span className="calculater-container-pikpin">
                          {" "}
                          Height per packet (Cm)
                        </span>
                      }
                      dependencies={
                        ([`${field.name}length`], [`${field.name}width`])
                      }
                      {...restField}
                      style={style}
                      name={[field.name, "height"]}
                      rules={[
                        {
                          required: true,
                          message: "Please enter  value",
                        },
                        ({ getFieldValue, setFieldsValue }) => ({
                          validator(_, value, callBack) {
                            const formdata = form
                              .getFieldValue("fields")
                              .find((item, index) => index === name);

                            let totalValue =
                              (+formdata?.width * +formdata?.lengt * +value) /
                              5000;

                            const newform = [];

                            form.getFieldValue("fields").map((item, i) => {
                              if (i === name) {
                                const data = {
                                  ...item,
                                  totalweight: totalValue.toFixed(2),
                                };
                                newform.push(data);
                              } else {
                                const data = {
                                  ...item,
                                };
                                newform.push(data);
                              }
                            });

                            callBack(
                              form.setFieldsValue({
                                fields: newform,
                              })
                            );
                          },
                        }),
                      ]}
                      onChange={(e) => handleChange(e)}
                      onKeyPress={(event) => {
                        if (checkNumbervalue(event)) {
                          event.preventDefault();
                        }
                      }}
                    >
                      <Input
                        type="number"
                        className="pincodeInput"
                        placeholder="Enter height"
                        maxLength={3}
                        min={"0"}
                        onKeyPress={(e) => {
                          if (e.target.value.length >= 3) {
                            e.target.value = e.target.value.substring(
                              0,
                              e.target.value.length - 1
                            );
                          }
                          if (e.code === "Minus") {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={lg} sm={sm} md={md}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Please enter  value",
                        },
                      ]}
                      label={
                        <span className="calculater-container-pikpin">
                          {" "}
                          Total Vol Weight (Kg)
                        </span>
                      }
                      {...restField}
                      style={style}
                      name={[field.name, "totalweight"]}
                      onKeyPress={(event) => {
                        if (checkNumbervalue(event)) {
                          event.preventDefault();
                        }
                      }}
                    >
                      <Input
                        type="number"
                        className="pincodeInput"
                        value={1}
                        maxLength={3}
                        readOnly={true}
                      />
                    </Form.Item>
                  </Col>
                  {arrOfData.length > 1 && (
                    <Col lg={4} md={2} className="delete-child-input">
                      <Tooltip placement="right" title={"Delete"}>
                        <Button
                          // type="text"
                          style={{
                            background: "white",
                            color: "black",
                            marginTop: "20px",
                            border: "1px solid #F55F5F",
                          }}
                          onClick={() => {
                            setFieldValue(name);
                          }}
                        >
                          <img
                            src={crosImgForChildBagagge}
                            className="delete-child-input-button"
                          />{" "}
                          <text
                            style={{ paddingLeft: "5px", color: "#F55F5F" }}
                          >
                            REMOVE{" "}
                          </text>
                        </Button>
                      </Tooltip>{" "}
                    </Col>
                  )}
                </Row>
              ))}
            </div>
          );
        }}
      </Form.List>
    </div>
  );
}

InputListsTest.propTypes = {
  name: PropTypes.string,
  setFieldValue: PropTypes.object,
  lg: PropTypes.number,
};
